import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { optionalUpgrades } from '../../data/mock';

const UpgradesSection = () => {
  return (
    <section className="bg-bg-primary">
      <div className="grid lg:grid-cols-2 min-h-[500px]">
        {/* Text Content */}
        <div className="flex flex-col justify-center px-6 lg:px-12 xl:px-20 py-16 lg:py-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-text-primary leading-tight mb-6">
            {optionalUpgrades.title}
          </h2>
          <p className="text-lg text-text-secondary mb-8 max-w-lg">
            {optionalUpgrades.intro}
          </p>
          <p className="text-sm text-text-light italic max-w-lg">
            {optionalUpgrades.note}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-rows-2">
          {/* Included as Standard */}
          <div className="bg-bg-secondary p-8 lg:p-12 flex flex-col justify-center">
            <h3 className="text-lg font-medium text-text-primary mb-6 flex items-center gap-2">
              <Check className="w-5 h-5 text-accent-green" />
              {optionalUpgrades.standard.title}
            </h3>
            <div className="space-y-3">
              {optionalUpgrades.standard.items.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-accent-green" />
                  <span className="text-text-secondary">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Optional Extras */}
          <div className="bg-accent-orange/10 p-8 lg:p-12 flex flex-col justify-center">
            <h3 className="text-lg font-medium text-text-primary mb-6 flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-accent-orange" />
              {optionalUpgrades.extras.title}
            </h3>
            <div className="space-y-3">
              {optionalUpgrades.extras.items.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-2 h-2 bg-accent-orange" />
                  <span className="text-text-secondary">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpgradesSection;
